import React from "react";
import { useIntl } from "react-intl";

//Components
import { Grid } from "@mui/material";
const Summary = (props) => {
    const { changes, vehicleClass, vehicleClassOptions } = props
    const { messages } = useIntl();

    return (
        <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="flex-start"
            spacing={1}
        >
            <Grid item={12}>
                <h3 style={{ marginTop: 0 }}>{messages['cameraSetup_are_you_sure_want_to_apply']}</h3>
                <p>{messages['cameraSetup_clicking_apply']}</p>
                <p>{messages['cameraSetup_the_following_changes']}:</p>
                <div>
                    {/*General*/}
                    {
                        changes?.eventThreshold && vehicleClass?.id &&
                        <p style={{ margin: '5px 0' }}>
                            <strong>{messages['cameraSetup_vehicle_class']}: </strong>
                            {vehicleClassOptions.length ? vehicleClassOptions.find((item) => item?.id === vehicleClass?.id)?.name : vehicleClass?.name}
                        </p>
                    }
                    {
                        changes?.advanced?.driverID &&
                        <p style={{ margin: '5px 0' }}>
                            <strong>{messages['cameraSetup_driver_id']}: </strong>{changes?.advanced?.driverID?.uploadFace ? messages['cameraSetup_on_full'] : messages['cameraSetup_off_full']}
                        </p>
                    }
                    {
                        changes?.rotate &&
                        <p style={{ margin: '5px 0' }}>
                            <strong>{messages['cameraSetup_camera_orientation']}: </strong>{messages[`cameraSetup_${changes?.rotate}`] || changes?.rotate}
                        </p>
                    }
                    {
                        changes?.advanced?.aux?.angle &&
                        <p style={{ margin: '5px 0' }}>
                            <strong>{messages['cameraSetup_aux_one_orientation']}: </strong>{messages[`cameraSetup_${changes?.advanced?.aux?.angle}`] || changes?.advanced?.aux?.angle}
                        </p>
                    }
                    {
                        changes?.advanced?.aux?.angle2 &&
                        <p style={{ margin: '5px 0' }}>
                            <strong>{messages['cameraSetup_aux_two_orientation']}: </strong>{messages[`cameraSetup_${changes?.advanced?.aux?.angle2}`] || changes?.advanced?.aux?.angle2}
                        </p>
                    }
                    {
                        changes?.volume?.speaker &&
                        <p style={{ margin: '5px 0' }}>
                            <strong>{messages['cameraSetup_volume']}: </strong>{changes?.volume?.speaker}
                        </p>
                    }
                    {/*Events*/}
                    {
                        (changes?.eventLevel?.HARD_ACCEL || changes?.sounds?.acc?.HARD_ACCEL) &&
                        <p style={{ margin: '5px 0' }}>
                            <strong>{messages['cameraSetup_rapid_acceleration']}:</strong>
                            {
                                changes?.eventLevel?.HARD_ACCEL ? ` ${messages['cameraSetup_trigger']}: ${changes?.eventLevel?.HARD_ACCEL === "LOW" ? messages['cameraSetup_on_full'] : messages['cameraSetup_off_full']}` : ''
                            }
                            {
                                changes?.sounds?.acc?.HARD_ACCEL ? ` ${messages['cameraSetup_audio']}: ${changes?.sounds?.acc?.HARD_ACCEL === "on" ? messages['cameraSetup_on_full'] : messages['cameraSetup_off_full']}` : ''
                            }
                        </p>
                    }
                    {
                        (changes?.eventLevel?.HARD_BRAKE || changes?.sounds?.acc?.HARD_BRAKE) &&
                        <p style={{ margin: '5px 0' }}>
                            <strong>{messages['cameraSetup_hard_brake']}:</strong>
                            {
                                changes?.eventLevel?.HARD_BRAKE ? ` ${messages['cameraSetup_trigger']}: ${changes?.eventLevel?.HARD_BRAKE === "LOW" ? messages['cameraSetup_on_full'] : messages['cameraSetup_off_full']}` : ''
                            }
                            {
                                changes?.sounds?.acc?.HARD_BRAKE ? ` ${messages['cameraSetup_audio']}: ${changes?.sounds?.acc?.HARD_BRAKE === "on" ? messages['cameraSetup_on_full'] : messages['cameraSetup_off_full']}` : ''
                            }
                        </p>
                    }
                    {
                        (changes?.eventLevel?.SHARP_TURN || changes?.sounds?.acc?.SHARP_TURN) &&
                        <p style={{ margin: '5px 0' }}>
                            <strong>{messages['cameraSetup_hard_turn']}:</strong>
                            {
                                changes?.eventLevel?.SHARP_TURN ? ` ${messages['cameraSetup_trigger']}: ${changes?.eventLevel?.SHARP_TURN === "LOW" ? messages['cameraSetup_on_full'] : messages['cameraSetup_off_full']}` : ''
                            }
                            {
                                changes?.sounds?.acc?.SHARP_TURN ? ` ${messages['cameraSetup_audio']}: ${changes?.sounds?.acc?.SHARP_TURN === "on" ? messages['cameraSetup_on_full'] : messages['cameraSetup_off_full']}` : ''
                            }
                        </p>
                    }
                    {
                        (changes?.eventLevel?.POWER_LOST || changes?.sounds?.power) &&
                        <p style={{ margin: '5px 0' }}>
                            <strong>{messages['cameraSetup_power_off']}:</strong>
                            {
                                changes?.eventLevel?.POWER_LOST ? ` ${messages['cameraSetup_trigger']}: ${changes?.eventLevel?.POWER_LOST === "DEFAULT" ? messages['cameraSetup_on_full'] : messages['cameraSetup_off_full']}` : ''
                            }
                            {
                                changes?.sounds?.power ? ` ${messages['cameraSetup_audio']}: ${changes?.sounds?.power === "on" ? messages['cameraSetup_on_full'] : messages['cameraSetup_off_full']}` : ''
                            }
                        </p>
                    }
                    {/*DMS*/}
                    {
                        (changes?.eventLevel?.DMS?.USING_PHONE || changes?.advanced?.safetyAssistance?.alarm?.USING_CELLPHONE || changes?.sounds?.dms?.USING_PHONE) &&
                        <p style={{ margin: '5px 0' }}>
                            <strong>{messages['cameraSetup_using_phone']}:</strong>
                            {
                                changes?.eventLevel?.DMS?.USING_PHONE ? ` ${messages['cameraSetup_trigger']}: ${changes?.eventLevel?.DMS?.USING_PHONE === "DEFAULT" ? messages['cameraSetup_on_full'] : messages['cameraSetup_off_full']}` : ''
                            }
                            {
                                changes?.advanced?.safetyAssistance?.alarm?.USING_CELLPHONE ? ` ${messages['cameraSetup_warning']}: ${changes?.advanced?.safetyAssistance?.alarm?.USING_CELLPHONE?.enable ? `${messages['cameraSetup_on_full']} (${messages['cameraSetup_count']}: ${changes?.advanced?.safetyAssistance?.alarm?.USING_CELLPHONE?.cnt})` : messages['cameraSetup_off_full']}` : ''
                            }
                            {
                                changes?.sounds?.dms?.USING_PHONE ? ` ${messages['cameraSetup_audio']}: ${changes?.sounds?.dms?.USING_PHONE === "on" ? messages['cameraSetup_on_full'] : messages['cameraSetup_off_full']}` : ''
                            }
                        </p>
                    }
                    {
                        (changes?.eventLevel?.DMS?.SMOKING || changes?.sounds?.dms?.SMOKING) &&
                        <p style={{ margin: '5px 0' }}>
                            <strong>{messages['cameraSetup_smoking']}:</strong>
                            {
                                changes?.eventLevel?.DMS?.SMOKING ? ` ${messages['cameraSetup_trigger']}: ${changes?.eventLevel?.DMS?.SMOKING === "DEFAULT" ? messages['cameraSetup_on_full'] : messages['cameraSetup_off_full']}` : ''
                            }
                            {
                                changes?.sounds?.dms?.SMOKING ? ` ${messages['cameraSetup_audio']}: ${changes?.sounds?.dms?.SMOKING === "on" ? messages['cameraSetup_on_full'] : messages['cameraSetup_off_full']}` : ''
                            }
                        </p>
                    }
                    {
                        (changes?.eventLevel?.DMS?.DROWSINESS || changes?.sounds?.dms?.DROWSINESS) &&
                        <p style={{ margin: '5px 0' }}>
                            <strong>{messages['cameraSetup_drowsy']}:</strong>
                            {
                                changes?.eventLevel?.DMS?.DROWSINESS ? ` ${messages['cameraSetup_trigger']}: ${changes?.eventLevel?.DMS?.DROWSINESS === "DEFAULT" ? messages['cameraSetup_on_full'] : messages['cameraSetup_off_full']}` : ''
                            }
                            {
                                changes?.sounds?.dms?.DROWSINESS ? ` ${messages['cameraSetup_audio']}: ${changes?.sounds?.dms?.DROWSINESS === "on" ? messages['cameraSetup_on_full'] : messages['cameraSetup_off_full']}` : ''
                            }
                        </p>
                    }
                    {
                        (changes?.eventLevel?.DMS?.NO_SEATBELT || changes?.advanced?.safetyAssistance?.alarm?.NO_SEATBELT || changes?.sounds?.dms?.NO_SEATBELT) &&
                        <p style={{ margin: '5px 0' }}>
                            <strong>{messages['cameraSetup_no_seatbelt']}:</strong>
                            {
                                changes?.eventLevel?.DMS?.NO_SEATBELT ? ` ${messages['cameraSetup_trigger']}: ${changes?.eventLevel?.DMS?.NO_SEATBELT === "DEFAULT" ? messages['cameraSetup_on_full'] : messages['cameraSetup_off_full']}` : ''
                            }
                            {
                                changes?.advanced?.safetyAssistance?.alarm?.NO_SEATBELT ? ` ${messages['cameraSetup_warning']}: ${changes?.advanced?.safetyAssistance?.alarm?.NO_SEATBELT?.enable ? `${messages['cameraSetup_on_full']} (${messages['cameraSetup_count']}: ${changes?.advanced?.safetyAssistance?.alarm?.NO_SEATBELT?.cnt})` : messages['cameraSetup_off_full']}` : ''
                            }
                            {
                                changes?.sounds?.dms?.NO_SEATBELT ? ` ${messages['cameraSetup_audio']}: ${changes?.sounds?.dms?.NO_SEATBELT === "on" ? messages['cameraSetup_on_full'] : messages['cameraSetup_off_full']}` : ''
                            }
                        </p>
                    }
                    {
                        (changes?.eventLevel?.DMS?.DAYDREAMING || changes?.sounds?.dms?.DAYDREAMING) &&
                        <p style={{ margin: '5px 0' }}>
                            <strong>{messages['cameraSetup_daydreaming']}:</strong>
                            {
                                changes?.eventLevel?.DMS?.DAYDREAMING ? ` ${messages['cameraSetup_trigger']}: ${changes?.eventLevel?.DMS?.DAYDREAMING === "DEFAULT" ? messages['cameraSetup_on_full'] : messages['cameraSetup_off_full']}` : ''
                            }
                            {
                                changes?.sounds?.dms?.DAYDREAMING ? ` ${messages['cameraSetup_audio']}: ${changes?.sounds?.dms?.DAYDREAMING === "on" ? messages['cameraSetup_on_full'] : messages['cameraSetup_off_full']}` : ''
                            }
                        </p>
                    }
                    {
                        (changes?.eventLevel?.DMS?.YAWN || changes?.sounds?.dms?.YAWN) &&
                        <p style={{ margin: '5px 0' }}>
                            <strong>{messages['cameraSetup_yawn']}:</strong>
                            {
                                changes?.eventLevel?.DMS?.YAWN ? ` ${messages['cameraSetup_trigger']}: ${changes?.eventLevel?.DMS?.YAWN === "DEFAULT" ? messages['cameraSetup_on_full'] : messages['cameraSetup_off_full']}` : ''
                            }
                            {
                                changes?.sounds?.dms?.YAWN ? ` ${messages['cameraSetup_audio']}: ${changes?.sounds?.dms?.YAWN === "on" ? messages['cameraSetup_on_full'] : messages['cameraSetup_off_full']}` : ''
                            }
                        </p>
                    }
                    {
                        (changes?.eventLevel?.DMS?.ASLEEP || changes?.sounds?.dms?.ASLEEP) &&
                        <p style={{ margin: '5px 0' }}>
                            <strong>{messages['cameraSetup_asleep']}:</strong>
                            {
                                changes?.eventLevel?.DMS?.ASLEEP ? ` ${messages['cameraSetup_trigger']}: ${changes?.eventLevel?.DMS?.ASLEEP === "DEFAULT" ? messages['cameraSetup_on_full'] : messages['cameraSetup_off_full']}` : ''
                            }
                            {
                                changes?.sounds?.dms?.ASLEEP ? ` ${messages['cameraSetup_audio']}: ${changes?.sounds?.dms?.ASLEEP === "on" ? messages['cameraSetup_on_full'] : messages['cameraSetup_off_full']}` : ''
                            }
                        </p>
                    }
                    {
                        (changes?.eventLevel?.DMS?.DISTRACTED || changes?.advanced?.safetyAssistance?.alarm?.DISTRACTED || changes?.sounds?.dms?.DISTRACTED) &&
                        <p style={{ margin: '5px 0' }}>
                            <strong>{messages['cameraSetup_distracted']}:</strong>
                            {
                                changes?.eventLevel?.DMS?.DISTRACTED ? ` ${messages['cameraSetup_trigger']}: ${changes?.eventLevel?.DMS?.DISTRACTED === "DEFAULT" ? messages['cameraSetup_on_full'] : messages['cameraSetup_off_full']}` : ''
                            }
                            {
                                changes?.advanced?.safetyAssistance?.alarm?.DISTRACTED ? ` ${messages['cameraSetup_warning']}: ${changes?.advanced?.safetyAssistance?.alarm?.DISTRACTED?.enable ? `${messages['cameraSetup_on_full']} (${messages['cameraSetup_count']}: ${changes?.advanced?.safetyAssistance?.alarm?.DISTRACTED?.cnt})` : messages['cameraSetup_off_full']}` : ''
                            }
                            {
                                changes?.sounds?.dms?.DISTRACTED ? ` ${messages['cameraSetup_audio']}: ${changes?.sounds?.dms?.DISTRACTED === "on" ? messages['cameraSetup_on_full'] : messages['cameraSetup_off_full']}` : ''
                            }
                        </p>
                    }
                    {
                        (changes?.eventLevel?.DMS?.NO_DRIVER || changes?.advanced?.safetyAssistance?.alarm?.NO_DRIVER || changes?.sounds?.dms?.NO_DRIVER) &&
                        <p style={{ margin: '5px 0' }}>
                            <strong>{messages['cameraSetup_no_driver']}:</strong>
                            {
                                changes?.eventLevel?.DMS?.NO_DRIVER ? ` ${messages['cameraSetup_trigger']}: ${changes?.eventLevel?.DMS?.NO_DRIVER === "DEFAULT" ? messages['cameraSetup_on_full'] : messages['cameraSetup_off_full']}` : ''
                            }
                            {
                                changes?.advanced?.safetyAssistance?.alarm?.NO_DRIVER ? ` ${messages['cameraSetup_warning']}: ${changes?.advanced?.safetyAssistance?.alarm?.NO_DRIVER?.enable ? `${messages['cameraSetup_on_full']} (${messages['cameraSetup_count']}: ${changes?.advanced?.safetyAssistance?.alarm?.NO_DRIVER?.cnt})` : messages['cameraSetup_off_full']}` : ''
                            }
                            {
                                changes?.sounds?.dms?.NO_DRIVER ? ` ${messages['cameraSetup_audio']}: ${changes?.sounds?.dms?.NO_DRIVER === "on" ? messages['cameraSetup_on_full'] : messages['cameraSetup_off_full']}` : ''
                            }
                        </p>
                    }
                    {
                        changes?.eventLevel?.DMS?.IDLE_NO_DRIVER &&
                        <p style={{ margin: '5px 0' }}>
                            <strong>{messages['cameraSetup_idle_no_driver']}:</strong>
                            {
                                changes?.eventLevel?.DMS?.IDLE_NO_DRIVER ? ` ${messages['cameraSetup_trigger']}: ${changes?.eventLevel?.DMS?.IDLE_NO_DRIVER === "DEFAULT" ? messages['cameraSetup_on_full'] : messages['cameraSetup_off_full']}` : ''
                            }
                        </p>
                    }
                    {
                        (changes?.eventLevel?.DMS?.PASSENGERS_INSIDE || changes?.sounds?.dms?.PASSENGERS_INSIDE) &&
                        <p style={{ margin: '5px 0' }}>
                            <strong>{messages['cameraSetup_passenger_detection']}: </strong>
                            {
                                changes?.eventLevel?.DMS?.PASSENGERS_INSIDE ? ` ${messages['cameraSetup_trigger']}: ${changes?.eventLevel?.DMS?.PASSENGERS_INSIDE === "DEFAULT" ? messages['cameraSetup_on_full'] : messages['cameraSetup_off_full']}` : ''
                            }
                            {
                                changes?.sounds?.dms?.PASSENGERS_INSIDE ? ` ${messages['cameraSetup_audio']}: ${changes?.sounds?.dms?.PASSENGERS_INSIDE === "on" ? messages['cameraSetup_on_full'] : messages['cameraSetup_off_full']}` : ''
                            }
                        </p>
                    }
                    {
                        (changes?.eventLevel?.DMS?.PASSENGERS_NO_SEATBELT || changes?.advanced?.safetyAssistance?.alarm?.PASSENGERS_NO_SEATBELT || changes?.sounds?.dms?.PASSENGERS_NO_SEATBELT) &&
                        <p style={{ margin: '5px 0' }}>
                            <strong>{messages['cameraSetup_passengers_no_seatbelt']}:</strong>
                            {
                                changes?.eventLevel?.DMS?.PASSENGERS_NO_SEATBELT ? ` ${messages['cameraSetup_trigger']}: ${changes?.eventLevel?.DMS?.PASSENGERS_NO_SEATBELT === "DEFAULT" ? messages['cameraSetup_on_full'] : messages['cameraSetup_off_full']}` : ''
                            }
                            {
                                changes?.advanced?.safetyAssistance?.alarm?.PASSENGERS_NO_SEATBELT ? ` ${messages['cameraSetup_warning']}: ${changes?.advanced?.safetyAssistance?.alarm?.PASSENGERS_NO_SEATBELT?.enable ? `${messages['cameraSetup_on_full']} (${messages['cameraSetup_count']}: ${changes?.advanced?.safetyAssistance?.alarm?.PASSENGERS_NO_SEATBELT?.cnt})` : messages['cameraSetup_off_full']}` : ''
                            }
                            {
                                changes?.sounds?.dms?.PASSENGERS_NO_SEATBELT ? ` ${messages['cameraSetup_audio']}: ${changes?.sounds?.dms?.PASSENGERS_NO_SEATBELT === "on" ? messages['cameraSetup_on_full'] : messages['cameraSetup_off_full']}` : ''
                            }
                        </p>
                    }
                    {/* ADAS */}
                    {
                        (changes?.eventLevel?.ADAS?.FORWARD_COLLISION || changes?.sounds?.adas?.FORWARD_COLLISION_WARNING) &&
                        <p style={{ margin: '5px 0' }}>
                            <strong>{messages['cameraSetup_collision_warning']}:</strong>
                            {
                                changes?.eventLevel?.ADAS?.FORWARD_COLLISION ? ` ${messages['cameraSetup_trigger']}: ${changes?.eventLevel?.ADAS?.FORWARD_COLLISION === "WARNING" ? messages['cameraSetup_on_full'] : messages['cameraSetup_off_full']}` : ''
                            }
                            {
                                changes?.sounds?.adas?.FORWARD_COLLISION_WARNING ? ` ${messages['cameraSetup_audio']}: ${changes?.sounds?.adas?.FORWARD_COLLISION_WARNING === "on" ? messages['cameraSetup_on_full'] : messages['cameraSetup_off_full']}` : ''
                            }
                        </p>
                    }
                    {/* {
                        (changes?.eventLevel?.ADAS?.HEADWAY_MONITORING || changes?.advanced?.safetyAssistance?.alarm?.TAILGATING || changes?.sounds?.adas?.HEADWAY_MONITORING_EMERGENCY) &&
                        <p style={{ margin: '5px 0' }}>
                            <strong>{messages['cameraSetup_tailgating']}:</strong>
                            {
                                changes?.eventLevel?.ADAS?.HEADWAY_MONITORING ? ` ${messages['cameraSetup_trigger']}: ${changes?.eventLevel?.ADAS?.HEADWAY_MONITORING === "EMERGENCY" ? messages['cameraSetup_on_full'] : messages['cameraSetup_off_full']}` : ''
                            }
                            {
                                changes?.advanced?.safetyAssistance?.alarm?.TAILGATING ? ` ${messages['cameraSetup_warning']}: ${changes?.advanced?.safetyAssistance?.alarm?.TAILGATING.enable ? `${messages['cameraSetup_on_full']} (${messages['cameraSetup_count']}: ${changes?.advanced?.safetyAssistance?.alarm?.TAILGATING.cnt})` : messages['cameraSetup_off_full']}` : ''
                            }
                            {
                                changes?.sounds?.adas?.HEADWAY_MONITORING_EMERGENCY ? ` ${messages['cameraSetup_audio']}: ${changes?.sounds?.adas?.HEADWAY_MONITORING_EMERGENCY === "on" ? messages['cameraSetup_on_full'] : messages['cameraSetup_off_full']}` : ''
                            }
                        </p>
                    } */}
                    {
                        (changes?.eventLevel?.ADAS?.LANE_DEPARTURE || changes?.advanced?.safetyAssistance?.alarm?.LANE_DEPARTURE || changes?.sounds?.adas?.LANE_DEPARTURE_WARNING) &&
                        <p style={{ margin: '5px 0' }}>
                            <strong>{messages['cameraSetup_lane_departure']}:</strong>
                            {
                                changes?.eventLevel?.ADAS?.LANE_DEPARTURE ? ` ${messages['cameraSetup_trigger']}: ${changes?.eventLevel?.ADAS?.LANE_DEPARTURE === "WARNING" ? messages['cameraSetup_on_full'] : messages['cameraSetup_off_full']}` : ''
                            }
                            {
                                changes?.advanced?.safetyAssistance?.alarm?.LANE_DEPARTURE ? ` ${messages['cameraSetup_warning']}: ${changes?.advanced?.safetyAssistance?.alarm?.LANE_DEPARTURE ? `${messages['cameraSetup_on_full']} (${messages['cameraSetup_count']}: ${changes?.advanced?.safetyAssistance?.alarm?.LANE_DEPARTURE?.cnt})` : messages['cameraSetup_off_full']}` : ''
                            }
                            {
                                changes?.sounds?.adas?.LANE_DEPARTURE_WARNING ? ` ${messages['cameraSetup_audio']}: ${changes?.sounds?.adas?.LANE_DEPARTURE_WARNING === "on" ? messages['cameraSetup_on_full'] : messages['cameraSetup_off_full']}` : ''
                            }
                        </p>
                    }
                    {
                        (changes?.eventLevel?.ADAS?.STOP_SIGN_VIOLATION || changes?.sounds?.adas?.STOP_SIGN_VIOLATION) &&
                        <p style={{ margin: '5px 0' }}>
                            <strong>{messages['cameraSetup_stop_sign_violation']}:</strong>
                            {
                                changes?.eventLevel?.ADAS?.STOP_SIGN_VIOLATION ? ` ${messages['cameraSetup_trigger']}: ${changes?.eventLevel?.ADAS?.STOP_SIGN_VIOLATION === "WARNING" ? messages['cameraSetup_on_full'] : messages['cameraSetup_off_full']}` : ''
                            }
                            {
                                changes?.sounds?.adas?.STOP_SIGN_VIOLATION ? ` ${messages['cameraSetup_audio']}: ${changes?.sounds?.adas?.STOP_SIGN_VIOLATION === "on" ? messages['cameraSetup_on_full'] : messages['cameraSetup_off_full']}` : ''
                            }
                        </p>
                    }

                    {
                        (changes?.eventLevel?.ADAS?.PEDESTRIAN_COLLISION || changes?.sounds?.adas?.PEDESTRIAN_COLLISION) &&
                        <p style={{ margin: '5px 0' }}>
                            <strong>{messages['cameraSetup_pedestrian_collision']}:</strong>
                            {
                                changes?.eventLevel?.ADAS?.PEDESTRIAN_COLLISION ? ` ${messages['cameraSetup_trigger']}: ${changes?.eventLevel?.ADAS?.PEDESTRIAN_COLLISION === "WARNING" ? messages['cameraSetup_on_full'] : messages['cameraSetup_off_full']}` : ''
                            }
                            {
                                changes?.sounds?.adas?.PEDESTRIAN_COLLISION ? ` ${messages['cameraSetup_audio']}: ${changes?.sounds?.adas?.PEDESTRIAN_COLLISION === "on" ? messages['cameraSetup_on_full'] : messages['cameraSetup_off_full']}` : ''
                            }
                        </p>
                    }
                    {
                        (changes?.eventLevel?.ADAS?.CYCLIST_COLLISION || changes?.sounds?.adas?.CYCLIST_COLLISION) &&
                        <p style={{ margin: '5px 0' }}>
                            <strong>{messages['cameraSetup_cyclist_collision']}:</strong>
                            {
                                changes?.eventLevel?.ADAS?.CYCLIST_COLLISION ? ` ${messages['cameraSetup_trigger']}: ${changes?.eventLevel?.ADAS?.CYCLIST_COLLISION === "WARNING" ? messages['cameraSetup_on_full'] : messages['cameraSetup_off_full']}` : ''
                            }
                            {
                                changes?.sounds?.adas?.CYCLIST_COLLISION ? ` ${messages['cameraSetup_audio']}: ${changes?.sounds?.adas?.CYCLIST_COLLISION === "on" ? messages['cameraSetup_on_full'] : messages['cameraSetup_off_full']}` : ''
                            }
                        </p>
                    }

                </div>
            </Grid>
        </Grid>
    )
}

export default Summary